import { render, staticRenderFns } from "./AddonGa.vue?vue&type=template&id=54eee1da&scoped=true&"
import script from "./AddonGa.vue?vue&type=script&lang=js&"
export * from "./AddonGa.vue?vue&type=script&lang=js&"
import style0 from "./AddonGa.vue?vue&type=style&index=0&id=54eee1da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eee1da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
